import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import translatedJson from '../translation/translation.json'
// Make a deep copy of translatedJson
const initialTranslations = JSON.parse(JSON.stringify(translatedJson))
// Initialize i18next
i18n.use(initReactI18next).init({
  resources: {
    en: { translation: initialTranslations }, // Use a deep copy here
  },
  lng: 'en',
  fallbackLng: 'en',
  supportedLngs: ['en', 'ar', 'ja'],
  debug: false,
  interpolation: {
    escapeValue: false,
    prefix: '{{',
    suffix: '}}',
  },
  react: {
    bindI18n: 'loaded languageChanged',
    bindI18nStore: 'added',
    useSuspense: true,
  },
})

export default i18n
